import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectFiles } from 'store/slices/files';

export const useSelectedFile = () => {
  const dispatch = useDispatch();
  const selectedFiles = useSelector((state) => state.files.selectedFiles);

  const selectFileData = useCallback(
    (file) => {
      if (!file) {
        dispatch(selectFiles([]));
        return;
      }

      dispatch(selectFiles(Array.isArray(file) ? file : [file]));
    },
    [dispatch]
  );

  const hasSelectedMultiple = useMemo(() => selectedFiles.length > 1, [selectedFiles]);

  return { selectedFiles, hasSelectedMultiple, selectFileData };
};
